export const clearAndScale = (
  ctx: CanvasRenderingContext2D,
  cssW: number,
  cssH: number
) => {
  ctx.clearRect(0, 0, cssW, cssH);
};
